export default "__VITE_ASSET__0176998a__"